import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Entity } from '../Classes/EntityClass';
import { AutoImportstatus } from '../Classes/AutoImportStatusClass';
import 'rxjs/add/operator/map';
import { CommonSearch } from '../Classes/CommonClass';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class AutoImportService {
  constructor(private http: Http) { }

  ApiRootPath: string = "api/AutoImport/";

  /***************Below Code for Auto Import****************/
  GetAutoImportSearchResult(_CommonSearch: CommonSearch) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "SearchQuery": JSON.stringify(_CommonSearch.SearchQuery) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get(this.ApiRootPath + 'GetAutoImportStatusByEHid', options)
      .map((res: Response) => res.json());

  }

  GetAutoImportSearchResultbyDate(_CommonSearch: CommonSearch) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "SearchQuery": JSON.stringify(_CommonSearch.SearchQuery) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get(this.ApiRootPath + 'GetAutoImportStatusByEHidbyDate', options)
      .map((res: Response) => res.json());

  }

}



// WEBPACK FOOTER //
// ./src/app/Services/AutoImportServices.ts